<template>
  <div class="page-body user-profile">
    <b-row no-gutters>
      <b-col md="12">
        <user-info @updateData="updateVerifications"/>
        <hr class="mr-3 ml-3"/>
      </b-col>
      <!-- general info card -->

      <b-col md="12">
        <Documents/>
        <hr class="mr-3 ml-3"/>
      </b-col>

      <b-col md="12">
        <PersonalInfo :verifications="verifications"/>
        <hr class="mr-3 ml-3"/>
      </b-col>

      <!-- end general info card -->
      <b-col md="12">
        <Cards/>
        <hr class="mr-3 ml-3"/>
      </b-col>
      <b-col md="12">
        <IBan/>
        <hr class="mr-3 ml-3"/>
      </b-col>
      <b-col md="12">
        <IBanPending/>
        <hr class="mr-3 ml-3"/>
      </b-col>
      <b-col md="12">
        <CryptoReports/>
        <hr class="mr-3 ml-3"/>
      </b-col>
      <b-col md="12">
        <FiatReports/>
        <hr class="mr-3 ml-3"/>
      </b-col>
      <b-col md="12">
        <ManualFiatReports/>
        <hr class="mr-3 ml-3"/>
      </b-col>

      <b-col md="12">
        <TransactionReport/>
        <hr class="mr-3 ml-3"/>
      </b-col>

      <b-col md="12">
        <RewardReport/>
        <hr class="mr-3 ml-3"/>
      </b-col>

      <b-col md="12">
        <PerfectMoneyReport/>
        <hr class="mr-3 ml-3"/>
      </b-col>

      <b-col md="12">
        <DustingReport/>
        <hr class="mr-3 ml-3"/>
      </b-col>


      <b-col md="12">
        <OpenWithdrawals/>
        <hr class="mr-3 ml-3"/>
      </b-col>

      <b-col md="12">
        <ManualBalanceChange :account-id="$route.params.id"/>
        <hr class="mr-3 ml-3"/>
      </b-col>

      <b-col md="12">
        <wallets/>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import UserInfo from "./components/UserInfo";
import OpenWithdrawals from "./components/OpenWithdrawals";
import Documents from "./components/Documents";
import Cards from "./components/Cards";
import IBan from "./components/IBan";
import IBanPending from "./components/IBanPending";
import CryptoReports from "./components/CryptoReports";
import FiatReports from "./components/FiatReports";
import ManualFiatReports from "./components/ManualFiatReports";
import Wallets from "./Wallets.vue";
import TransactionReport from "./components/TransactionReport";
import RewardReport from "./components/RewardReport";
import PerfectMoneyReport from "./components/PerfectMoneyReport";
import PersonalInfo from "@/views/Pages/Users/components/PersonalInfo";
import DustingReport from "@/views/Pages/Users/components/DustingReport";
import ManualBalanceChange from "@/views/Pages/Reports/ManualBalanceChange";

export default {
  components: {
    DustingReport,
    PersonalInfo,
    UserInfo,
    Documents,
    Cards,
    IBan,
    CryptoReports,
    FiatReports,
    Wallets,
    TransactionReport,
    RewardReport,
    IBanPending,
    OpenWithdrawals,
    PerfectMoneyReport,
    ManualFiatReports,
    ManualBalanceChange,
  },
  data() {
    return {
      verifications: [],
    };
  },
  methods: {
    updateVerifications(data) {
      this.verifications = Object.values(data);
    },
  },
};
</script>
<style lang="scss">
.user-profile {
  .card-header-text {
    font-size: 22px;
  }

  hr {
    margin: 24px 0px 24px 0px;
  }

  td,
  th {
    text-align: center !important;

    div {
      display: flex;
      justify-content: center;
    }
  }

  .modal-header .close {
    padding: 1.25rem;
    margin: -1rem -1rem -3rem auto;
    font-size: 37px;
  }

  .image-preview {
    width: 90%;
    border-radius: 4px;
    cursor: pointer;
  }

  .b-skeleton-input {
    margin-bottom: 24px;
  }

  .confirm-button {
    width: max-content;
    padding: 8px 12px;
  }

  .user-level-box-range-item {
    font-size: 14px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #424242;
    margin-right: 0;
    margin-bottom: 16px;
  }

  .user-level-box-info-item {
    margin-top: 24px;
  }

  .button-container {
    text-align: right;
    padding-top: 0px;
    padding-right: 0;
    padding-left: 0;

    button {
      margin-right: 0px;
    }

    .submit-skeleton {
      margin-right: 16px;
      border-radius: 4px;
    }

    .submit-button {
      margin-right: 16px;
      border-radius: 4px;
      background-color: #2a6ae3;
      color: #fff;
    }

    @media (max-width: 991px) {
      .submit-button {
        width: 100%;
      }
    }
  }

  @media (min-width: 992px) {
    .card-header {
      display: flex;
    }

    .info-section {
      display: none;
    }

    .left-section {
      padding-top: 24px;
    }
  }
}
</style>
